<script lang="ts">
  import Badge from 'Catalyst/components/Badge/Badge.svelte';
  import CatalystApp from 'Catalyst/components/CatalystApp/CatalystApp.svelte';
  import {deal, socialProofingDataStore} from 'Store/InvestorFlowStore';

  const engagedInvestorsFlag =
    $deal.feature_flags.investor_conversion_engaged_investors;
  const showEngagedInvestorsBadge = engagedInvestorsFlag
    ? $socialProofingDataStore.engagedInvestors >=
      $socialProofingDataStore.engagedInvestorsThreshold
    : false;
  const recentInvestorsFlag =
    $deal.feature_flags.investor_conversion_recent_investors;
  const showRecentInvestorsBadge = recentInvestorsFlag
    ? $socialProofingDataStore.recentInvestors >=
      $socialProofingDataStore.recentInvestorsThreshold
    : false;
  const totalInvestorsFlag =
    $deal.feature_flags.investor_conversion_total_investors;
  const showTotalInvestorsBadge = totalInvestorsFlag
    ? $socialProofingDataStore.totalInvestors >=
      $socialProofingDataStore.totalInvestorsThreshold
    : false;
</script>

<CatalystApp>
  <div
    class="social-proofing-badge-container"
    data-testid="social-proofing-badge-container"
  >
    {#if showEngagedInvestorsBadge}
      <Badge
        label={`${$socialProofingDataStore.engagedInvestors} eyeing this investment`}
        leadingEmojiGlyph="&#128064;"
        semantic="brand"
      />
    {/if}
    {#if showRecentInvestorsBadge}
      <Badge
        label={`${$socialProofingDataStore.recentInvestors} investors in ${$socialProofingDataStore.recentInvestorDateRangeDays} days`}
        leadingEmojiGlyph="&#x23F1;&#xFE0F;"
        semantic="brand"
      />
    {/if}
    {#if showTotalInvestorsBadge}
      <Badge
        label={`${$socialProofingDataStore.totalInvestors} total investors`}
        leadingEmojiGlyph="&#9889;"
        semantic="brand"
      />
    {/if}
  </div>
</CatalystApp>

<style>
  .social-proofing-badge-container {
    margin-top: 1.2rem;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    align-items: flex-start;
  }
</style>
